import type { ValidatedApiClient } from '../types/api-client';
import { FEATURE_FLAGS_API_PATH } from './constants';
import { featureFlagsSchema } from './schema';

export const createFeaturesApi = ({ validatedFetch }: ValidatedApiClient) => ({
    get: () => validatedFetch(featureFlagsSchema, FEATURE_FLAGS_API_PATH, new URLSearchParams(), { cache: 'no-store' }),
});
